export class GroupPerm {
    public Permission!: string;
    public GroupId!: number;
    public UserGroup!: string;
    public Groups!: string;
}
